export default "__VITE_ASSET__DYTLyGBl__"